<template>
<div class="common-table">
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="20" type="flex">
          <a-col>
            <a-form-item label="Query" style="width:230px;">
              <a-input v-model="queryParam.name" placeholder="Name / Number" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="Gender" style="width:150px;">
              <a-select v-model="queryParam.gender" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="M">Male</a-select-option>
                <a-select-option value="F">Female</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="Website" style="width:230px;">
              <a-select v-model="queryParam.registerSite" placeholder="Please select" default-value="0" @change="refreshCurrentPage" :dropdownMatchSelectWidth="false">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="signettours.com">signettours.com</a-select-option>
                <a-select-option value="signettours.ca">signettours.ca</a-select-option>
                <a-select-option value="superatours.com">superatours.com</a-select-option>
                <a-select-option value="superatours.ca">superatours.ca</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-show="false">
            <a-form-item label="Status" style="width:160px;">
              <a-select v-model="queryParam.auditStatus" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="0">Pending</a-select-option>
                <a-select-option value="1">Approved</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = { name: '', gender: '', registerSite: '', auditStatus: '' }">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-card>
    <!-- <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('CDB_MEMBERSHIP_ADD')">New</a-button>
    </div> -->
  <a-card :bordered="false">
    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
      style="display: table;"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="coupon" slot-scope="couponList">
        <span v-if="couponList && couponList.length > 0 && couponList[0].usageStatus === '1'">Used</span>
        <span v-else>Available</span>
      </span>

      <div slot="writeDate" slot-scope="text, record">
        <a-tooltip placement="top">
          <template slot="title">
            <div style="font-weight:500;margin-right: 6px;">{{ record.changeBy.userName }}</div>
            <div>{{ DateTimeUtil().localString(record.writeDate !== null ? record.writeDate : record.createDate) }}</div>
          </template>
          <div>
            <div>
              {{ DateTimeUtil().utcString(record.writeDate !== null ? record.writeDate : record.createDate, 'MM/DD/YYYY') }}
            </div>
          </div>
        </a-tooltip>
      </div>

      <div slot="fullName" slot-scope="text">
        {{ text ? text.replace(/,/g, ', ') : ''}}
      </div>

      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" :disabled="!$auth('CDB_MEMBERSHIP_EDIT')"><a-icon type="edit" /></a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="Are you sure delete?"
            @confirm="onDeleteConfirmed(record)"
            okText="Yes"
            cancelText="No"
          >
            <a href="javascript:;" :disabled="!$auth('CDB_MEMBERSHIP_DELETE')"><a-icon type="delete" style="color:#eb2f96;"/></a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
  </a-card>
</div>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import MembershipApi from '@/api/api-cdb-membership'

export default {
  name: 'MembershipList',
  components: {
    STable
  },
  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { name: '', gender: '', registerSite: '', auditStatus : '' },
      // 表头
      columns: [
        {
          title: '#',
          width: '35px',
          scopedSlots: { customRender: 'serial' },
          align:'center'
        },
        {
          title: 'Name',
          dataIndex: 'fullName',
          scopedSlots: { customRender: 'fullName' },
        },
        {
          title: 'No.',
          dataIndex: 'membershipCode',
          align:'center'
        },
        {
          title: 'Gender',
          dataIndex: 'gender',
          customRender: (value) => (value === 'M') ? 'Male' : 'Female',
          align:'center'
        },
        {
          title: 'DOB',
          dataIndex: 'birthday',
          customRender: (value) => this.dateFormatB(value),
          align:'center'
        },
        /* {
          title: 'CDB No.',
          dataIndex: 'customerCode'
        }, */
        {
          title: 'Website',
          dataIndex: 'registerSite',
          align:'center'
        },
        {
          title: 'Last Modified',
          dataIndex: 'writeDate',
          scopedSlots: { customRender: 'writeDate' },
          align:'center'
        },
        {
          title: 'Coupon',
          dataIndex: 'couponList',
          scopedSlots: { customRender: 'coupon' },
          align:'center'
        },
        {
          title: '',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align:'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return MembershipApi.query(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      MembershipApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    handleOk () {
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
.overflow-hidden{
  width: 100%;
  position: relative;
  text-align: left;
}
.overflow-hidden > div{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  left: 0;
}
::v-deep .ant-table-tbody > tr > td {
  vertical-align: top;
}
</style>